import React, { useState, useEffect } from "react";

const CustomTimePicker = ({
  propertyEarlyCheckInTime,
  propertyCheckInTime,
  onChange,
  disabled,
}) => {
  const [timeOptions, setTimeOptions] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  // Convert time string in "HH:mm" format to a Date object for comparison
  const convertTimeStringToDate = (timeString) => {
    const [hours, minutes] = timeString.split(":");
    const date = new Date();
    date.setHours(parseInt(hours));
    date.setMinutes(parseInt(minutes));
    date.setSeconds(0); // set seconds to 0 for consistency
    return date;
  };

  useEffect(() => {
    if (propertyCheckInTime) {
      setSelectedTime(propertyCheckInTime); // Default selected time
    }
  }, [propertyCheckInTime]);

  useEffect(() => {
    const generateTimeOptions = () => {
      const options = [];
      const start = convertTimeStringToDate(propertyCheckInTime);
      const end = convertTimeStringToDate(propertyEarlyCheckInTime);

      // Generate time options in 15-minute intervals (counting backward)
      while (start > end) {
        // Use 24-hour format for time options
        options.push(
          start.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          }) // 24-hour format
        );
        start.setMinutes(start.getMinutes() - 15);
      }

      setTimeOptions(options);
    };

    if (propertyEarlyCheckInTime && propertyCheckInTime) {
      generateTimeOptions();
    }
  }, [propertyEarlyCheckInTime, propertyCheckInTime]);

  const handleChange = (time) => {
    setSelectedTime(time);
    onChange(time);
    setIsOpen(false);
  };

  // Convert selectedTime to Date for comparison
  const selectedTimeDate = convertTimeStringToDate(selectedTime);
  const propertyCheckInTimeDate = convertTimeStringToDate(propertyCheckInTime);

  return (
    <div className="relative">
      <div
        onClick={(e) => {
          e.preventDefault();
          if (!disabled) {
            setIsOpen(!isOpen);
          }
        }}
        className="w-full border border-gray-300 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer"
      >
        {selectedTime || "Select a time"}
      </div>
      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded shadow-lg max-h-60 overflow-auto">
          {timeOptions.length > 0 ? (
            timeOptions.map((time, index) => (
              <div
                key={index}
                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  handleChange(time);
                }}
              >
                {time}
              </div>
            ))
          ) : (
            <div className="px-3 py-2 text-gray-500">
              No time options available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomTimePicker;
